import {SYSTEMSETTING} from 'Constants/ActionTypes'; 
const actions={
  getMarketList(){
    return {
      type: SYSTEMSETTING.GET_SOUND_MARKET_LIST,
      payload: {
        request: {
          method: 'get',
          url: `/robot/tts/voices`,
        },
      },
    };
  },
  getMarketUrl(data){ 
    return {
      type: SYSTEMSETTING.GET_SOUND_MARKET_URL,
      payload: {
        request: {
          method: 'post',
          url: `/robot/tts/online`,
          data:data
        },
      },
    };
  }
}
export default actions;